import { render, staticRenderFns } from "./CModal.vue?vue&type=template&id=0d7a2796"
import script from "./CModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./CModal.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports